import * as React from "react";
const SvgFiRrNetworkCloud = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-network-cloud_svg__a)">
      <path
        fill="#062147"
        d="M23 20h-8.184A3 3 0 0 0 13 18.184v-4.162c1.344 0 2.52-.012 3.095-.023q.54-.01 1.066-.13a4.95 4.95 0 0 0 3.7-3.7 5.013 5.013 0 0 0-3.559-6l-.172-.039c-.3-.067-.45-.1-.588-.429a6 6 0 0 0-11.367.857 6.4 6.4 0 0 0-.057 2.732 3.5 3.5 0 0 0 .449 6.588q.41.108.833.122c.655.018 2.534.026 4.494.026H11v4.16A3 3 0 0 0 9.184 20H1a1 1 0 1 0 0 2h8.184a2.982 2.982 0 0 0 5.632 0H23a1 1 0 0 0 0-2M6.456 12a1.473 1.473 0 0 1-1.4-1.076 1.5 1.5 0 0 1 .851-1.8 2.015 2.015 0 0 0 1.18-2.3A4 4 0 0 1 10.982 2 4.01 4.01 0 0 1 14.7 4.469 2.64 2.64 0 0 0 16.784 6.1a3.023 3.023 0 0 1 2.132 3.622 2.974 2.974 0 0 1-2.858 2.274c-.693.013-8.847.024-9.602.004M12 22a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-network-cloud_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrNetworkCloud;
